import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"
import Block from "components/Template/Block"
import React from "react"
import styles from "./styles"

const TwoColumnLowerThird = ({ children, classes, blocks, event }) => (
  <div className={classes.template}>
    {blocks.map(block => {
      return (
        <div key={block.id} className={classes[block.id]}>
          <div
            className={classnames({
              [classes.blockContainer]: block.name,
              [classes.blockContainerEmpty]: !block.name
            })}
          >
            <Block block={block} event={event} />
          </div>
        </div>
      )
    })}
  </div>
)

export default withStyles(styles, { withTheme: true })(TwoColumnLowerThird)



// WEBPACK FOOTER //
// ./src/components/Template/Layouts/TwoColumnLowerThird/index.jsx